var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, computed, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
import { AvailableTooltip } from '../../../components/other/AvailableTooltip';
let CycleDotReward_ = class CycleDotReward_ extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get isRewardActive() {
        const { app } = this.props;
        const answer = app.stage.itemOnStage;
        if (!answer || answer.type !== 'answer')
            return false;
        if (answer.miniQuestion && answer.miniQuestion.questionType === 'CycleEnd')
            return true;
        return false;
    }
    get backgroundColor() {
        const lightGrey = 'rgba(0,0,0,0.15)';
        const yellow = '#ed9a00';
        const green = '#7ca71f';
        const red = '#b91111';
        if (this.isRewardActive) {
            return green;
        }
        return lightGrey;
    }
    get boxShadow() {
        if (this.isRewardActive) {
            return '0px 0px 2px 2px rgba(255,204,0,0.7)';
        }
        return undefined;
    }
    get color() {
        if (this.isRewardActive) {
            this.performConfettiSpread();
            return '#d8b40a';
        }
        return 'rgba(255, 255, 255, 0.7)';
    }
    get textShadow() {
        // if (this.props.answer.answerInfo.isCurrentAnswer) return '0px 0px 1px rgba(255,204,0,0.5)';
        return undefined;
    }
    isRewardDotHovering = false;
    performConfettiSpread() {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.isRewardDotHovering = true;
            setTimeout(action(() => (this.isRewardDotHovering = false)), 1000);
        });
    }
    render() {
        const { app } = this.props;
        const x = this.preloadedReward;
        const y = this.preloadedBranding;
        return (React.createElement(AvailableTooltip, { title: "Am Ende des Lerndurchgangs wartet eine Belohnung auf dich!" },
            React.createElement("div", { style: {
                    backgroundColor: this.backgroundColor,
                    boxShadow: this.boxShadow,
                    color: this.color,
                    textShadow: this.textShadow,
                    flex: '1 1 auto',
                    padding: '2px 0px 2px 0px',
                    borderRadius: 2,
                    margin: 1,
                    textAlign: 'center',
                    display: 'flex',
                    marginLeft: 2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 18,
                    height: 26,
                }, onClick: this.showCycleEndHint, onMouseEnter: action(() => (this.isRewardDotHovering = true)), onMouseLeave: action(() => (this.isRewardDotHovering = false)) },
                React.createElement("i", { className: "fas fa-gift" }),
                this.confetti)));
    }
    showCycleEndHint() {
        // alert('Die Belohnung wird dir angezeigt, wenn du alle Fragen beantwortet hast.');
        // this.props.answer.stageMe();
    }
    /*
    @action.bound
    preloadAnswer() {
      const preload = this.props.answer.answerPrepare.isPrepared;
    }
  */
    get confettiConfig() {
        return {
            angle: 90,
            spread: 45,
            startVelocity: 45,
            elementCount: 50,
            dragFriction: 0.1,
            duration: 3000,
            delay: 0,
            width: '10px',
            height: '10px',
            colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
        };
    }
    get confetti() {
        if (!runtime.availablePackages.Lazy)
            return null;
        const { Confetti } = runtime.availablePackages.Lazy.components;
        return React.createElement(Confetti, { active: this.isRewardDotHovering, config: this.confettiConfig });
    }
    get preloadedReward() {
        const { app } = this.props;
        if (app.cycle.frontalIndex < 14)
            return null;
        const answer = app.cycle.cycleReward.rewardAnswer;
        if (!answer)
            return null;
        const question = answer.streamedQuestion;
        if (question) {
            const x = question.questionPrepare.isAnyThingPending;
        }
        return null;
    }
    get preloadedBranding() {
        const { app } = this.props;
        if (app.cycle.frontalIndex < 14)
            return null;
        const answer = app.cycle.cycleBranding.brandingAnswer;
        if (!answer)
            return null;
        if (answer.app.cycle.frontalIndex < 5)
            return null;
        const question = answer.streamedQuestion;
        if (question) {
            const x = question.questionPrepare.isAnyThingPending;
        }
        return null;
    }
};
__decorate([
    computed
], CycleDotReward_.prototype, "color", null);
__decorate([
    observable
], CycleDotReward_.prototype, "isRewardDotHovering", void 0);
__decorate([
    action.bound
], CycleDotReward_.prototype, "showCycleEndHint", null);
__decorate([
    computed
], CycleDotReward_.prototype, "preloadedReward", null);
__decorate([
    computed
], CycleDotReward_.prototype, "preloadedBranding", null);
CycleDotReward_ = __decorate([
    observer
], CycleDotReward_);
export { CycleDotReward_ };
